var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApple = function SvgApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 44
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "black",
    d: "M19.82 13.138c1.083 0 2.44-.732 3.25-1.708.732-.885 1.266-2.121 1.266-3.357 0-.168-.015-.336-.046-.473-1.205.046-2.655.809-3.524 1.83-.687.779-1.313 2-1.313 3.25 0 .184.031.367.046.428.077.015.199.03.32.03M16.005 31.6c1.48 0 2.136-.992 3.983-.992 1.876 0 2.288.961 3.936.961 1.617 0 2.7-1.495 3.723-2.96 1.144-1.678 1.617-3.326 1.648-3.402-.107-.03-3.205-1.297-3.205-4.852 0-3.082 2.442-4.47 2.579-4.577-1.617-2.32-4.074-2.38-4.745-2.38-1.816 0-3.296 1.098-4.226 1.098-1.007 0-2.335-1.037-3.906-1.037-2.99 0-6.027 2.472-6.027 7.14 0 2.9 1.13 5.966 2.517 7.95 1.19 1.678 2.228 3.051 3.723 3.051"
  })));
};
export default SvgApple;